import mappingActivity from './mapping-activity-ru';
/**
 * Russian Localization
 */

export default {
  mappingActivity,
  // CR-0068: spec/frontend/ui-dictionary.md, first complete mapping path.
  mapping: {
    // frontend-class-mappings-R49; spec/frontend/ui-dictionary.md (CR-0073).
    enumTargetUnavailable: "Для перечисления маппинг недоступен.",
    contextHelp: {
      name: "Имя этого набора данных во вкладке. Несколько наборов могут использовать одну таблицу источника.",
      description: "Из каких таблиц и по каким условиям получается набор: связи, фильтры и группировка. Через {'@'} можно вставить ссылку.",
      sourceSelection: "Получать весь набор при каждом запуске или только изменения после предыдущей загрузки.",
      initial: "Условие выборки для первого запуска, когда предыдущей загрузки ещё не было.",
      subsequent: "Условие отбора изменений при следующих запусках. Например, дата изменения больше метки предыдущей успешной загрузки.",
      businessWrite: "Добавлять новые записи, добавлять и обновлять существующие по ключу либо полностью заменять данные.",
      deletions: "Нужно ли отражать в бизнес-модели признак удаления записи, полученный из источника.",
    },
    tablesAndColumns: "Таблицы и колонки",
    createNameHint: "Например, Заказы с позициями",
    createDescriptionHint: "Опишите набор. {'@'} — таблицы и колонки",
    editDescriptionHint: "Опишите таблицы, соединения, фильтры и группировку. {'@'} — ссылка на источник",
    descriptionHelp: "Можно описать одну таблицу или набор из нескольких таблиц.",
    loadHelp: "Выборка определяет данные для STAGE. Запись — обновление бизнес-слоя.",
    editDataset: "Изменить набор {dataset}",
    editLoad: "Изменить загрузку {dataset}",
    loadParameters: "Параметры загрузки",
    sourceSelection: "Выборка из источника",
    businessWrite: "Запись в бизнес-слой",
    deletions: "Удалённые записи",
    selectionOptions: { full: "Целиком", incremental: "Инкрементально" },
    writeOptions: { upsert: "Добавлять и обновлять (upsert)", insert: "Только добавлять (insert)", replace: "Заменять целиком (truncate + insert)" },
    deletionOptions: { ignore: "Не обрабатывать", flag: "Учитывать признак удаления" },
    conditionSummary: "{value} {comparison} {operand} → «{then}», иначе «{otherwise}»",
    preview: "В маппинге",
    onDate: "на дату",
    listParameter: "Список",
    details: "Шаблон, ошибки и дополнительные параметры",
    done: "Готово",
    close: "Закрыть",
    list: "Значение списка",
    relation: "По связи",
    condition: "Условие",
    constant: "Константа",
    empty: "Не заполняется",
    rule: "Правило",
    sourceSystem: "Система-источник",
    globalSystem: "Общий",
    currentDatasetSystem: "Система текущего набора",
    atDate: "На дату",
    dateHint: "Не задана — текущее значение",
    formExpressionHint: "Текст или формула; {'@'} — колонка",
    listMode: "Получение значения",
    recoding: "Таблица перекодировки",
    value: "Значение",
    reason: "Причина",
    path: "Путь по связи",
    comparison: "Сравнение",
    operand: "С чем",
    then: "Тогда",
    otherwise: "Иначе",
    onEmpty: "Если пусто",
    onNotFound: "Если не найдено",
    onDuplicateKey: "Если ключ повторяется",
    listModes: { expression: "Выражение или колонка", constant: "Заданное значение", recoding: "Таблица перекодировки" },
    comparisons: { greater: "больше", equal: "равно", less: "меньше" },
    policyValues: { leaveEmpty: "Оставить пустым", skipRecord: "Пропустить запись", stopLoad: "Остановить загрузку", first: "Взять первую запись", last: "Взять последнюю запись" },
    more: "⋯",
    datasetActions: "Действия с маппингом {dataset}",
    deleteDataset: "Удалить маппинг",
    deleteConfirmation: "Удалить маппинг?",
    deleteWarning: "Описание набора, правила полей и параметры загрузки будут удалены. Таблицы источников и класс останутся.",
    load: "Загрузка",
    conditions: "Условия выборки",
    initial: "Первоначально",
    subsequent: "Последующие загрузки",
    subsequentSummary: "Далее",
    selection: { full: "Полная выборка", incremental: "Инкрементальная выборка" },
    writeMode: { upsert: "Добавлять и обновлять", insert: "Только добавлять", replace: "Заменять целиком" },
    deletedRecords: { ignore: "Без обработки удалений", flag: "Учитывать признак удаления" },

    lookup: "Поиск по ключу",
    lookupDescription: "Класс · поле поиска · выражение",
    listDescription: "Список · значение или перекодировка",
    relationDescription: "Путь к связанному полю",
    conditionDescription: "Если · тогда · иначе",
    constantDescription: "Фиксированное значение",
    emptyDescription: "Осознанная пустота с причиной",
    template: "Шаблон",
    templateHelp: "Готовый способ заполнения поля. Задаёт структуру правила; значения его параметров можно изменять.",
    lookupKeysHelp: "Tab — следующий параметр; Enter — завершить; Esc — отменить незавершённый ввод.",
    searchClassHelp: "Класс бизнес-модели, в котором ищем запись. Например, «Покупатель»: по коду из источника находим покупателя и записываем ссылку на него. Это не таблица исходных данных.",
    searchFieldHelp: "Поле выбранного класса, с которым сравниваем искомое значение. Например, поле «Код» класса «Покупатель».",
    searchValueHelp: "Что ищем в выбранном классе. Например, {'@'}tx_sales.cust_cd — код покупателя из источника. Можно задать формулу из нескольких колонок.",
    text: "Текст с разметкой",
    in: "в",
    by: "по",
    searchClass: "Класс для поиска",
    searchField: "Поле поиска",
    searchValue: "Искомое значение",
    classHint: "класс",
    fieldHint: "поле поиска",
    expressionHint: "{'@'}колонка или формула",
    ruleHint: "Текст, {'@'} — колонка, / — шаблон",
    editing: "Редактирование {field}",
    cancelInput: "Отменить незавершённый ввод (Esc)",
    templates: "Шаблоны",
    nothingFound: "Ничего не найдено",
    editValue: "Изменить {field} · {dataset}",
    notSet: "Не задано",
    referenceNotFound: "Ссылка не найдена",
    key: "Ключ",
    technicalFields: "Технические поля",
    technicalNames: "Технические имена",
    currentLoadTime: "Время загрузки",
    previousLoadTime: "Предыдущая загрузка",
    effectiveFrom: "Действует с",
    notSaved: "Не сохранено",
    changing: "Изменяется…",
    saved: "Сохранено",
    untitled: "Без названия",
    retry: "Повторить",
    saveFailed: "Не удалось сохранить изменение",
    revisionConflict: "Маппинг изменился. Действие не выполнено.",
    datasets: "Наборы данных",
    all: "Все",
    addDataset: "Добавить набор данных",
    plus: "＋",
    dataset: "Набор данных",
    findField: "Найти поле",
    onlyEmpty: "Только незаполненные",
    field: "Поле",
    noFields: "Нет полей по выбранному фильтру",
    noDatasets: "Маппингов пока нет",
    addHelp: "Добавьте набор данных для заполнения полей класса.",
    name: "Название",
    description: "Как формируется",
    cancel: "Отмена",
    add: "Добавить",
  },


  /**
   * Общие тексты отказов — по машиночитаемому признаку причины.
   * Норма: spec/backend/invariants/api-errors.md (R04, R06–R08).
   * Зональные признаки ищутся раньше: `<зона>.errors.<признак>`.
   */
  errors: {
    INTERNAL_ERROR: 'Сбой на стороне продукта. Повторите позже',
    NOTE_FORMAT_NOT_MARKDOWN: 'Заметка сохраняется в формате Markdown. Уберите разметку HTML (тег «{tag}») — чтобы показать её примером, поместите её в код',
    NOT_FOUND: 'Объект не найден',
    // Опечатка в запросе отличима от «объекта нет» (invariants/api-errors).
    INVALID_ID: 'Некорректный идентификатор: «{id}»',
    INVALID_LIMIT: 'Некорректное количество записей: «{limit}»',
    // Запрос не той формы: продукт называет параметр отбора или поле данных,
    // из-за которого действие отклонено (api-errors-R06, R07). Названия может
    // не быть — тогда берётся безымянный вариант текста (`_UNNAMED`).
    QUERY_PARAM_UNKNOWN:
        'Запрос содержит параметр отбора «{param}», который продукт не принимает. Обновите страницу и повторите',
    QUERY_PARAM_UNKNOWN_UNNAMED:
        'Запрос содержит параметр отбора, который продукт не принимает. Обновите страницу и повторите',
    QUERY_PARAM_MISSING:
        'В запросе не хватает обязательного параметра отбора «{param}». Обновите страницу и повторите',
    QUERY_PARAM_MISSING_UNNAMED:
        'В запросе не хватает обязательного параметра отбора. Обновите страницу и повторите',
    QUERY_PARAM_INVALID:
        'Значение параметра отбора «{param}» недопустимо. Измените условия отбора и повторите',
    QUERY_PARAM_INVALID_UNNAMED:
        'Значение одного из параметров отбора недопустимо. Измените условия отбора и повторите',
    BODY_INVALID:
        'Продукт не смог разобрать отправленные данные. Обновите страницу и повторите — если отказ повторяется, сообщите администратору',
    BODY_FIELD_UNKNOWN:
        'В отправленных данных есть поле «{field}», которое продукт не принимает. Обновите страницу и повторите',
    BODY_FIELD_UNKNOWN_UNNAMED:
        'В отправленных данных есть поле, которое продукт не принимает. Обновите страницу и повторите',
    BODY_FIELD_MISSING:
        'В отправленных данных не хватает обязательного поля «{field}». Заполните его и повторите',
    BODY_FIELD_MISSING_UNNAMED:
        'В отправленных данных не хватает обязательного поля. Заполните обязательные поля и повторите',
    BODY_FIELD_INVALID:
        'Значение поля «{field}» недопустимо. Исправьте его и повторите',
    BODY_FIELD_INVALID_UNNAMED:
        'Значение одного из полей недопустимо. Проверьте введённые данные и повторите',
    METHOD_NOT_ALLOWED: 'Действие не поддерживается для этого адреса',
    UNKNOWN_ERROR: 'Не удалось выполнить действие',
    NETWORK_ERROR: 'Нет связи с сервером. Проверьте подключение и повторите',
    LOAD_FAILED: 'Не удалось загрузить данные',
    CREATE_FAILED: 'Не удалось создать',
    UPDATE_FAILED: 'Не удалось обновить',
    DELETE_FAILED: 'Не удалось удалить',
    // Архивный коммит только для чтения
    // (spec/backend/business-model/versioning.md, R25).
    FEATURE_IS_ARCHIVED_COMMIT: 'Это архивный коммит — его содержимое доступно только для чтения. Переключитесь на текущую версию фичи',
    // Название проекта: непустота и уникальность
    // (spec/backend/administration/projects.md, R04; spec/backend/invariants/naming.md).
    PROJECT_NAME_EMPTY: 'Название проекта не может быть пустым',
    // Удержания фичи при удалении
    // (spec/backend/business-model/feature-lifecycle.md, R13).
    FEATURE_HELD_BY_DESCENDANTS:
        'У фичи есть ответвления ({descendants}): удалить её нельзя, пока они существуют',
    FEATURE_HELD_BY_DATAMARTS:
        'В фиче есть витрины ({datamarts}) и папки витрин ({folders}): удалить её нельзя, пока они существуют. Чтобы скрыть фичу и сохранить её содержимое, переведите её в архив',
    PROJECT_NAME_EXISTS: 'Проект с названием «{name}» уже есть',
    // Название фичи: уникальность в проекте и закрытый перечень статусов
    // (spec/backend/business-model/features.md, R04, R06); непустота после
    // нормализации (spec/backend/business-model/feature-lifecycle.md, R05).
    FEATURE_NAME_EMPTY: 'Укажите название фичи',
    FEATURE_NAME_EXISTS: 'Фича с названием «{name}» в проекте уже есть',
    FEATURE_STATUS_INVALID: 'Недопустимый статус фичи: «{status}». Допустимы: {allowed}',
    // Переданное название ветки, пустое после нормализации, — отказ
    // (spec/backend/business-model/versioning.md, business-model-versioning-R30).
    BRANCH_NAME_EMPTY: 'Название ветки не может быть пустым',
    // Ключ шифрования сменился: сохранённые секреты источников зашифрованы
    // прежним ключом и не читаются. Пользователь обязан понять причину и выход
    // (spec/backend/invariants/encryption.md, R06, R07).
    ENCRYPTION_KEY_MISMATCH:
        'Секрет подключения зашифрован прежним ключом шифрования и больше не читается. Введите секрет заново и сохраните источник',
    // Отказ пути синхронизации/профилирования метаданных: причина и параметры
    // приходят машиночитаемыми (api-errors-R06, R07), а не свободной строкой
    // (spec/notes/archive/bugs/2026-08-10_17-30_sync-history-drops-failure-reason.md).
    SOURCE_ERROR: 'Источник недоступен или отклонил запрос. Проверьте источник и повторите позже',
    SYNC_TIMEOUT: 'Синхронизация не уложилась в отведённое время ({seconds} с)',
    SYNC_FAILED: 'Синхронизация не удалась',
    PROFILING_TIMEOUT: 'Профилирование не уложилось в отведённое время ({seconds} с)',
    PROFILING_FAILED: 'Профилирование не удалось',
    HTTP_400: 'Запрос отклонён: некорректные данные',
    HTTP_401: 'Сессия истекла. Войдите заново',
    // api-errors-R04/R08; rbac-R13.
    ACCESS_DENIED: 'У вас нет разрешения на это действие',
    HTTP_403: 'У вас нет разрешения на это действие',
    HTTP_404: 'Объект не найден',
    HTTP_409: 'Действие противоречит текущему состоянию',
    HTTP_422: 'Запрос отклонён: некорректные данные',
    HTTP_500: 'Сбой на стороне продукта. Повторите позже',
    HTTP_502: 'Сбой на стороне продукта. Повторите позже',
    HTTP_503: 'Продукт временно недоступен. Повторите позже',
  },
  common: {
    cancel: 'Отмена',
    save: 'Сохранить',
    create: 'Создать',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    loading: 'Загрузка...',
    close: 'Закрыть',
    details: 'Детали',
    actions: 'Действия',
    name: 'Название',
    description: 'Описание',
    required: 'Обязательно',
    rename: 'Переименовать',
    admin: 'Админ',
    saveSuccess: 'Успешно сохранено',
    saveError: 'Не удалось сохранить',
    noteNotLoaded: 'Заметка не загружена — редактирование недоступно. Повторите попытку',
    loadError: 'Не удалось загрузить данные',
  },
  
  app: {
    title: 'MetaBridge',
    menu: 'Меню',
  },
  
  nav: {
    mappings: 'Маппинги',
    sourceExplorer: 'Обзор источников',
    businessLayer: 'Бизнес-слой',
    etl: 'ETL',
    admin: {
      users: 'Пользователи',
    },
  },
  
  project: {
    createStandalone: 'создать проект',
    select: 'Проект',
    create: 'Создать новый проект...',
    createTitle: 'Создать новый проект',
    name: 'Название проекта',
    namePlaceholder: 'Мой проект',
    description: 'Описание',
    descriptionPlaceholder: 'Описание проекта (опционально)',
    created: 'Проект "{name}" создан!',
    loadError: 'Не удалось загрузить список проектов',
    createError: 'Не удалось создать проект',
    // Проект из ссылки не существует либо не виден актору — одно и то же
    // (shell-routing-R12, rbac-R23): подмены доступным проектом нет.
    notFoundInLink: 'Проект из ссылки не найден',
  },
  
  source: {
    dataSources: 'Источники данных',
    statisticsRefreshed: 'Статистика таблицы обновлена',
    addSource: 'Добавить источник данных',
    addSourceTitle: 'Добавить новый источник данных',
    editSourceTitle: 'Редактировать источник данных',
    name: 'Название источника',
    namePlaceholder: 'Моя база данных',
    type: 'Тип базы данных',
    host: 'Хост',
    port: 'Порт',
    database: 'Название базы данных',
    username: 'Имя пользователя',
    password: 'Пароль',
    passwordPlaceholder: 'Оставьте пустым, чтобы сохранить текущий пароль',
    testConnection: 'Проверить подключение',
    testConnectionSuccess: 'Подключение успешно!',
    testConnectionFailed: 'Ошибка подключения',
    created: 'Источник "{name}" успешно создан!',
    updated: 'Источник "{name}" успешно обновлён!',
    createError: 'Не удалось создать источник',
    updateError: 'Не удалось обновить источник',
    notSynced: 'Не синхронизирован',
    // Состояния синхронизации источника в подсказке узла дерева. Ключей не
    // было ни в одной локали, и пользователь видел сам ключ (i18n-R02).
    synced: 'Синхронизирован',
    syncing: 'Синхронизация выполняется',
    loadError: 'Не удалось загрузить источники',
    // Сбой открытия рабочей области подключения, шаблона файлов, конечной
    // точки или топика; ключа не было ни в одной локали (BUG-0006, i18n-R02).
    loadFailed: 'Не удалось загрузить данные источника',
    notFound: 'Источник не найден: {name}',
    syncSuccess: 'Метаданные успешно синхронизированы',
    syncQueued: 'Соединение установлено, синхронизация поставлена в очередь',
    syncError: 'Не удалось синхронизировать метаданные',
    refresh: 'Обновить метаданные',
    settings: 'Настройки источника',
    selectSourceFirst: 'Пожалуйста, выберите источник',
    schema: 'Схема',
    table: 'Таблица',
    selectTable: 'Выберите таблицу для просмотра колонок',
    neverSynced: 'Ещё не синхронизирован. Нажмите Обновить для загрузки метаданных.',
    lastSyncFailed: 'Ошибка синхронизации {timeAgo}',
    lastSynced: 'Синхронизировано {timeAgo}',
    justNow: 'только что',
    minutesAgo: '{count} мин назад',
    hoursAgo: '{count} ч назад',
    daysAgo: '{count} дн назад',
    description: 'Описание источника',
    descriptionPlaceholder: 'Опишите этот источник данных...',
    descriptionEditHint: 'Нажмите Esc для отмены',
    clickToAddDescription: 'Нажмите, чтобы добавить описание',
    copyLink: 'Копировать ссылку на источник',
    linkCopied: 'Ссылка на источник скопирована',
    linkCopyFailed: 'Не удалось скопировать ссылку на источник',
    deleteTitle: 'Удаление источника',
    deleteConfirm: 'Удалить источник «{name}»? Все метаданные, заметки и теги будут скрыты.',
    deleteSuccess: 'Источник «{name}» удалён',
    deleteError: 'Не удалось удалить источник',
    noDeletePermission: 'Нет прав на удаление источника',
    moreActions: 'Ещё',
    schemasTitle: 'Схемы',
    schemasEmpty: 'В этом источнике нет схем',
    schemasHidden: 'Скрыта',
    schemasHiddenCount: 'Скрыто: {count}',
    schemasNoDescription: 'Нет описания',
    schemasNoTags: 'Без тегов',
    schemasSearchPlaceholder: 'Поиск по схемам...',
    schemasVisibilityPlaceholder: 'Видимость',
    schemasFilterAll: 'Показать все',
    schemasFilterHidden: 'Только скрытые',
    schemasFilterVisible: 'Без скрытых',
    schemasTagsPlaceholder: 'Фильтр по тегам',
    schemaName: 'Схема',
    schemaTables: 'Таблицы',
    schemaDescription: 'Описание',
    schemaTags: 'Теги',
    schemasHide: 'Скрывать',
    schemasLoadFailed: 'Не удалось загрузить схемы источника',
    hiddenSchemasLoadFailed: 'Не удалось загрузить скрытые схемы',
    hiddenSchemasSaveFailed: 'Не удалось сохранить скрытые схемы',
    schemaNotesLoadFailed: 'Не удалось загрузить описания схем',
    moveToGroup: {
      action: 'Перенести в другую группу',
      title: 'Перенос источника',
      message: 'Выберите группу для источника «{name}»:',
      selectGroup: 'Выберите группу',
      confirm: 'Перенести',
      success: 'Источник «{name}» перенесён в группу «{group}»',
      noOtherGroups: 'Нет других групп для переноса',
      error: 'Не удалось перенести источник',
    },
    ssh: {
      tab: 'SSH-туннель',
      enable: 'Использовать SSH-туннель',
      host: 'SSH-хост',
      port: 'SSH-порт',
      username: 'SSH-пользователь',
      authMethod: 'Аутентификация',
      authPassword: 'Пароль',
      authPrivateKey: 'Приватный ключ',
      password: 'SSH-пароль',
      privateKeyPath: 'Путь к приватному ключу',
      privateKeyPathPlaceholder: '/home/user/.ssh/id_rsa',
      passphrase: 'Пароль ключа',
      timeout: 'Таймаут подключения (с)',
      keepalive: 'Поддерживать соединение',
      keepaliveInterval: 'Интервал (с)',
      testConnection: 'Тест SSH',
      testSuccess: 'SSH-подключение успешно!',
      testFailed: 'SSH-подключение не удалось',
      passwordPlaceholder: 'Оставьте пустым для сохранения текущего',
      advanced: 'Дополнительно',
    },
    andMoreTables: '...и ещё {count}',
    tableType: {
      table: 'Таблица',
      view: 'Представление',
      materializedView: 'Материализованное представление',
    },
    odbc: {
      driver: 'ODBC-драйвер',
      driverPlaceholder: 'Выберите ODBC-драйвер',
      driverLoading: 'Загрузка драйверов...',
      noDrivers: 'На сервере не найдены ODBC-драйверы',
      template: 'Шаблон подключения',
      templatePlaceholder: 'Выберите тип БД',
      templateLoading: 'Загрузка шаблонов...',
      unavailable: 'ODBC не доступен на сервере',
    },
    errors: {
      TAG_CODE_EMPTY: 'Код тега не может быть пустым',
      TAG_NAME_EMPTY: 'Название тега не может быть пустым',
      TAG_COLOR_INVALID: 'Некорректный код цвета: {color}',
      TAG_CODE_EXISTS: 'Тег с кодом "{code}" в проекте уже есть',
      ODBC_DRIVER_LIST_FAILED: 'Не удалось получить список ODBC-драйверов',
      ODBC_NO_DRIVERS: 'На сервере не установлены ODBC-драйверы',
      ODBC_TEMPLATE_NOT_FOUND: 'Шаблон подключения "{templateId}" не найден',
      ODBC_FIELD_MISSING: 'Обязательное поле "{field}" не заполнено',
      ODBC_FIELD_INVALID: 'Некорректное значение поля "{field}": {reason}',
      ODBC_BUILD_CONN_STR_FAILED: 'Не удалось собрать строку подключения',
      ODBC_CONNECT_FAILED: 'Ошибка подключения через ODBC',
      ODBC_METADATA_FAILED: 'Ошибка извлечения метаданных через ODBC',
      ODBC_ENV_INIT_FAILED: 'ODBC не доступен на сервере',
      SOURCE_NAME_EXISTS: 'Источник с таким именем уже существует',
      SOURCE_NAME_EMPTY: 'Название источника не может быть пустым',
      SOURCE_HOST_EMPTY: 'Укажите адрес источника',
      SOURCE_PORT_OUT_OF_RANGE: 'Порт должен быть от {min} до {max}',
      SOURCE_DATABASE_EMPTY: 'Укажите имя базы данных',
      SOURCE_USERNAME_EMPTY: 'Укажите имя пользователя',
      ODBC_DRIVER_NOT_SELECTED: 'Не выбран ODBC-драйвер',
      ODBC_TEMPLATE_NOT_SELECTED: 'Не выбран шаблон подключения',
      // Переход вверх по дереву каталогов запрещён во всех путевых значениях
      // дочернего объекта (spec/backend/data-sources/source-children.md, R14).
      PATH_TRAVERSAL_NOT_ALLOWED:
        'Значение не может содержать «..»: переход вверх по дереву каталогов запрещён (поле: {field})',
      NAME_EXISTS: 'Объект с названием "{name}" у этого источника уже есть',
      PROVIDER_CONFIG_KEY_UNKNOWN:
        'Неизвестная настройка разбора "{key}". Допустимые: {allowed}',
      SOURCE_DB_TYPE_UNSUPPORTED:
        'Способ подключения "{dbType}" не поддерживается. Допустимые: {allowed}. Остальные СУБД подключаются через ODBC',
      SOURCE_SECRET_UNKNOWN:
        'Секрет подключения "{code}" продукту неизвестен. Допустимые: {allowed}',
      ODBC_BUILD_FAILED: 'Не удалось собрать строку подключения ODBC',
      GROUP_NAME_EXISTS: 'Группа с таким названием уже существует',
      GROUP_HAS_SOURCES: 'Невозможно удалить группу: она содержит {count} источник(ов)',
      // Тип подключения и проект источника задаются при создании и изменению не
      // подлежат: тип определяет, что вообще может быть под источником
      // (spec/backend/data-sources/connection.md, R24; sources.md, R12).
      SOURCE_CONNECTION_TYPE_IMMUTABLE:
        'Тип подключения изменить нельзя: источник заведён как «{currentConnectionType}». Заведите новый источник типа «{connectionType}»',
      SOURCE_PROJECT_IMMUTABLE: 'Проект источника изменить нельзя',
      // Тип подключения у источника один: тип подключения и способ
      // подключения не указывают на разные типы
      // (spec/backend/data-sources/connection.md, R33).
      SOURCE_CONNECTION_TYPE_MISMATCH:
        'Тип подключения «{connectionType}» не совпадает со способом подключения «{dbType}»: у источника один тип подключения',
      // Вид родителя в дереве источников: подключение — только под группой,
      // дочерний объект — только под подключением или другим дочерним объектом
      // того же источника (spec/backend/storage/entities.md, «Иерархия»).
      PARENT_MUST_BE_GROUP: 'Подключение размещается только в группе',
      PARENT_FROM_ANOTHER_SOURCE: 'Выбранный родитель принадлежит другому источнику',
      NOT_FOUND: 'Объект не найден',
      SSH_AUTH_METHOD_INVALID:
        'Недопустимый способ SSH-аутентификации "{sshAuthMethod}". Допустимые: {allowed}',
      SSH_AUTH_METHOD_REQUIRED:
        'При включённом SSH-туннеле нужно указать способ аутентификации',
      // Пароль при способе «пароль» и путь к ключу при способе «приватный
      // ключ» обязательны (spec/backend/data-sources/ssh-tunnel.md, R04).
      SSH_PASSWORD_REQUIRED:
        'Для SSH-аутентификации паролем укажите пароль SSH',
      SSH_PRIVATE_KEY_PATH_REQUIRED:
        'Для SSH-аутентификации ключом укажите путь к приватному ключу',
      SSH_TIMEOUT_OUT_OF_RANGE:
        'Таймаут SSH должен быть от {min} до {max} секунд',
      SSH_KEEPALIVE_INTERVAL_INVALID:
        'Интервал проверки SSH-соединения должен быть не меньше {min} секунд',
      // Адрес SSH-сервера и имя пользователя туннеля
      // (spec/backend/data-sources/ssh-tunnel.md, R02, R11).
      SSH_HOST_EMPTY: 'Укажите хост SSH-сервера',
      SSH_PORT_OUT_OF_RANGE: 'Порт SSH должен быть от {min} до {max}',
      SSH_USERNAME_EMPTY: 'Укажите имя пользователя SSH',
      // Отказы выборки образца и вкладки «Данные» по признаку причины
      // (source-explorer-sample-data-R41, R45; api-errors-R04, R08).
      TABLE_ID_FORMAT_INVALID: 'Таблица задана неверно: ожидается полное имя «схема.таблица»',
      SAMPLE_DATA_NOT_CACHED: 'Образец данных таблицы ещё не загружен. Загрузите образец',
      SOURCE_PASSWORD_NOT_CONFIGURED: 'У источника не задан пароль подключения. Укажите пароль в настройках источника',
      ODBC_CONNECTION_STRING_MISSING: 'У ODBC-источника не задана строка подключения. Укажите её в настройках источника',
    },
    // Подписи полей, которые продукт называет параметром отказа `field`
    // (api-errors-R06): в тексте отказа — подпись, а не имя на проводе.
    errorFields: {
      sshPrivateKeyPath: 'Путь к приватному ключу',
    },
    tab: {
      general: 'Основные',
      ssh: 'SSH-туннель',
    },
  },

  group: {
    groups: 'Группы',
    addGroup: 'Добавить группу',
    addGroupTitle: 'Добавить новую группу',
    editGroupTitle: 'Редактировать группу',
    name: 'Название группы',
    namePlaceholder: 'Введите название группы',
    description: 'Описание',
    descriptionPlaceholder: 'Описание группы (необязательно)',
    sourceCount: '{count} источников',
    deleteConfirm: 'Вы уверены, что хотите удалить группу «{name}»?',
    created: 'Группа «{name}» создана',
    updated: 'Группа «{name}» обновлена',
    deleted: 'Группа удалена',
    loadError: 'Не удалось загрузить группы',
    workspace: {
      sourcesTitle: 'Источники',
      sourcesSearchPlaceholder: 'Поиск по источникам...',
      sourcesEmpty: 'В группе нет источников',
      sourceName: 'Источник',
      sourceSyncStatus: 'Статус синхронизации',
      sourceLastSynced: 'Последняя синхронизация',
      sourceSchemaCount: 'Схемы',
      settings: 'Настройки группы',
      copyLink: 'Копировать ссылку на группу',
      linkCopied: 'Ссылка на группу скопирована',
      linkCopyFailed: 'Не удалось скопировать ссылку на группу',
      deleteTitle: 'Удаление группы',
      deleteDisabledHasSources: 'Удалите все источники перед удалением группы',
      descriptionPlaceholder: 'Описание группы...',
      clickToAddDescription: 'Нажмите, чтобы добавить описание',
    },
  },

  schema: {
    notFound: 'Схема не найдена',
    description: 'Описание схемы',
    descriptionPlaceholder: 'Опишите эту схему...',
    descriptionEditHint: 'Нажмите Esc для отмены',
    clickToAddDescription: 'Нажмите, чтобы добавить описание',
    copyLink: 'Копировать ссылку на схему',
    linkCopied: 'Ссылка на схему скопирована',
    linkCopyFailed: 'Не удалось скопировать ссылку на схему',
    tablesTitle: 'Таблицы',
    tablesEmpty: 'В этой схеме нет таблиц',
    tablesShowHidden: 'Показать скрытые',
    tablesHide: 'Скрывать',
    tablesHidden: 'Скрыта',
    tablesHiddenCount: 'Скрыто: {count}',
    tablesNoDescription: 'Нет описания',
    tablesNoTags: 'Без тегов',
    tablesSearchPlaceholder: 'Поиск по таблицам...',
    tablesVisibilityPlaceholder: 'Видимость',
    tablesFilterAll: 'Показать все',
    tablesFilterHidden: 'Только скрытые',
    tablesFilterVisible: 'Без скрытых',
    tablesTagsPlaceholder: 'Фильтр по тегам',
    tableName: 'Таблица',
    tableColumns: 'Колонки',
    tableDescription: 'Описание',
    tableTags: 'Теги',
    tablesLoadFailed: 'Не удалось загрузить таблицы схемы',
    hiddenTablesLoadFailed: 'Не удалось загрузить скрытые таблицы',
    hiddenTablesSaveFailed: 'Не удалось сохранить скрытые таблицы',
    tableNotesLoadFailed: 'Не удалось загрузить описания таблиц',
    batchSelected: 'Выбрано: {count}',
    batchSelectPage: 'Выбрать страницу',
    batchSelectAll: 'Выбрать все ({count})',
    batchClear: 'Очистить',
    batchHide: 'Скрыть',
    batchUnhide: 'Показать',
    batchAddTag: 'Добавить тег',
    batchRemoveTag: 'Убрать тег',
    batchTagsUpdateFailed: 'Не удалось обновить теги таблиц',
  },
  
  table: {
    schemaUnknown: 'Схема таблицы неизвестна — данные не загружены',
    hasPk: 'Есть PK',
    pk: 'PK',
    fk: 'FK',
    columns: 'Колонки',
    rowsEst: 'Строк (прибл.)',
    columnName: 'Название колонки',
    dataType: 'Тип данных',
    nullable: 'Nullable',
    dbComment: 'Комментарий БД',
    noComment: 'Нет комментария',
    analystNote: 'Заметка аналитика',
    addNote: 'Добавить заметку',
    clickToAddNote: 'Кликните для добавления заметки...',
    noteEditPlaceholder: 'Введите заметку... (поддерживается форматирование)',
    noteEditHint: 'Используйте панель инструментов для форматирования. Кликните вне редактора чтобы сохранить.',
    noteSaved: 'Заметка сохранена',
    columnsSelected: 'колонок выбрано',
    selectAll: 'Выбрать все',
    clearSelection: 'Снять выделение',
    appendNote: 'Добавить заметку',
    batchAppendNoteTitle: 'Добавить заметку к выбранным колонкам',
    batchNotePlaceholder: 'Введите текст для добавления ко всем выбранным колонкам...',
    appendToSelected: 'Добавить к {count} колонкам',
    batchNotesSaved: 'Заметки добавлены к {count} колонкам',
    batchNotesSaveFailed: 'Не удалось добавить заметки',
    allColumnsReviewed: 'Все колонки проверены!',
    allColumnsReviewedDesc: 'У каждой колонки в этой таблице есть заметка аналитика. Отличная работа!',
    tableDescriptionPlaceholder: 'Опишите назначение и бизнес-контекст этой таблицы...',
    addTableDescription: 'Нажмите, чтобы добавить описание таблицы',
    editTableNoteHint: 'Нажмите Esc для отмены',
    tableNoteSaved: 'Описание таблицы сохранено',
    notNull: 'NOT NULL',
    yes: 'ДА',
    notFoundInCache: 'Метаданные таблицы не найдены в кэше',
    loadFailed: 'Не удалось загрузить таблицу',
    copyLink: 'Копировать ссылку',
    linkCopied: 'Ссылка скопирована в буфер обмена',
    linkCopyFailed: 'Не удалось скопировать ссылку',
    tabs: {
      columns: 'Колонки',
      schema: 'Схема',
      indexes: 'Индексы',
      constraints: 'Ограничения',
      data: 'Данные',
    },
    schemaEmpty: 'Связей не найдено',
    schemaLoadFailed: 'Не удалось загрузить схему таблицы',
    schemaPartialLoadFailed: 'Часть связанных таблиц не загрузилась',
    schemaRenderFailed: 'Не удалось отрисовать диаграмму',
    schemaRelationsTitle: 'Исходящие связи',
    schemaIncomingRelationsTitle: 'Входящие связи',
    schemaDiagramTitle: 'Диаграмма связей',
    schemaRelations: {
      constraintName: 'Имя связи',
      sourceColumn: 'Поле источника',
      targetTable: 'Целевая таблица',
      targetColumn: 'Поле назначения',
    },
    schemaIncomingRelations: {
      constraintName: 'Имя связи',
      sourceTable: 'Таблица-источник',
      sourceColumn: 'Поле источника',
      targetColumn: 'Поле назначения',
    },
    indexes: {
      name: 'Имя индекса',
      type: 'Тип',
      columns: 'Колонки',
      isUnique: 'Уникальный',
      isPrimary: 'Первичный',
      predicate: 'Условие (WHERE)',
      unique: 'UNIQUE',
      primary: 'PRIMARY',
      empty: 'Индексы не найдены',
      loadFailed: 'Не удалось загрузить индексы',
    },
    constraints: {
      name: 'Имя ограничения',
      type: 'Тип',
      columns: 'Колонки',
      referencedTable: 'Целевая таблица',
      referencedColumns: 'Целевые колонки',
      definition: 'Определение',
      empty: 'Ограничения не найдены',
      loadFailed: 'Не удалось загрузить ограничения',
    },
    dataTab: {
      whereLabel: 'WHERE',
      orderByLabel: 'ORDER BY',
      apply: 'Загрузить данные',
      clear: 'Очистить',
      errorTitle: 'Ошибка выполнения запроса',
    },
  },
  
  coverage: {
    reviewProgress: 'Прогресс проверки',
    total: 'Всего',
    withNotes: 'С заметками',
    needsReview: 'Требует проверки',
    pii: 'PII',
    noDbComment: 'Без комментария БД',
    changed: 'Изменено',
  },
  
  filter: {
    title: 'Фильтры',
    withNotes: 'С заметками',
    withoutNotes: 'Без заметок',
    withDbComment: 'С комментарием БД',
    noDbComment: 'Без комментария БД',
    keys: 'Ключи (PK/FK)',
    primaryKey: 'Первичный ключ',
    foreignKey: 'Внешний ключ',
    reviewMode: 'Режим проверки',
    clearAll: 'Очистить всё',
  },

  comments: {
    title: 'Комментарии',
    empty: 'Комментариев пока нет',
    placeholder: 'Напишите комментарий...',
    add: 'Добавить комментарий',
    retry: 'Повторить',
    loadFailed: 'Не удалось загрузить комментарии',
    createFailed: 'Не удалось добавить комментарий',
    /**
     * Тексты отказов ленты по признаку причины (comments-R11, i18n-R06):
     * ищутся как `comments.errors.<признак>` раньше общих.
     */
    errors: {
      COMMENT_BODY_EMPTY: 'Комментарий не может быть пустым',
      COMMENT_AUTHOR_NOT_ACCEPTED: 'Автор комментария задаётся продуктом и в запросе не принимается',
      COMMENT_ENTITY_NAME_AMBIGUOUS: 'Имя объекта неоднозначно: в источнике несколько объектов с таким именем',
      AUTHENTICATION_REQUIRED: 'Комментарий можно оставить только после входа в продукт',
      NOT_FOUND: 'Объект обсуждения не найден',
      NETWORK_ERROR: 'Не удалось загрузить комментарии: нет связи с сервером',
    },
  },

  tags: {
    title: 'Теги',
    placeholder: 'Теги',
    loadFailed: 'Не удалось загрузить теги',
    saveFailed: 'Не удалось сохранить теги',
  },
  
  auth: {
    userMenu: 'Меню пользователя',
    /**
     * Тексты отказов смены пароля по признаку причины
     * (password-change-R07, R08; основание: вердикт 250). Ищутся раньше общих:
     * `auth.errors.<признак>`.
     */
    errors: {
      INVALID_CREDENTIALS: 'Неверный текущий пароль',
      PASSWORD_TOO_WEAK: 'Пароль слишком слабый: минимум 8 символов',
      NEW_PASSWORD_SAME_AS_OLD: 'Новый пароль совпадает со старым',
    },
    profileLoadFailed: 'Не удалось обновить профиль. Повторите позже',
    sectionForbidden: 'Раздел доступен только администратору продукта',
    loginTitle: 'Вход в систему',
    login: 'Войти',
    loginOrEmail: 'Login или Email',
    logout: 'Выйти',
    logoutAll: 'Выйти везде',
    profile: 'Профиль',
    password: 'Пароль',
    changePassword: 'Сменить пароль',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтверждение пароля',
    mustChangePasswordWarning: 'Вы используете временный пароль. Пожалуйста, смените его.',
    passwordChanged: 'Пароль успешно изменен',
    invalidCredentials: 'Неверный login/email или пароль',
    sessionExpired: 'Сессия истекла. Пожалуйста, войдите снова.',
    loginSuccess: 'Вход выполнен успешно',
    loginError: 'Ошибка входа',
    identifierRequired: 'Введите login или email',
    passwordRequired: 'Введите пароль',
    oldPasswordRequired: 'Введите старый пароль',
    newPasswordRequired: 'Введите новый пароль',
    confirmPasswordRequired: 'Подтвердите новый пароль',
    passwordTooShort: 'Пароль должен содержать минимум {min} символов',
    passwordMustBeDifferent: 'Новый пароль должен отличаться от старого',
    passwordsDoNotMatch: 'Пароли не совпадают',
    invalidOldPassword: 'Неверный старый пароль',
    changePasswordError: 'Ошибка смены пароля',
  },
  
  sampleData: {
    title: 'Примеры данных',
    rows: 'строк',
    cached: 'Закэшировано',
    refresh: 'Обновить данные',
    export: 'Экспорт в CSV',
    loading: 'Загрузка данных...',
    noData: 'Нет данных для отображения',
    loadData: 'Загрузить данные',
    justNow: 'только что',
    minutesAgo: '{n} мин назад',
    hoursAgo: '{n} ч назад',
    daysAgo: '{n} дн назад',
    errorTitle: 'Ошибка загрузки данных',
    retry: 'Повторить',
  },
  
  sourceExplorer: {
    // Пометка исчерпанных попыток — НЕ признак причины отказа, а дополнение
    // к тексту причины (data-processing-metadata-sync-R08,
    // source-explorer-profiling-R07; api-errors-R07).
    errorAttemptsExhausted: 'Попытки исчерпаны',
    columnProfile: {
      title: 'Профиль колонки',
      loading: 'Профилирование в процессе...',
      loadingHint: 'Для больших таблиц это может занять несколько минут',
      error: 'Не удалось загрузить профиль',
      timeout: 'Превышено время ожидания. Попробуйте снова или проверьте размер таблицы.',
      refresh: 'Обновить',
      retry: 'Повторить попытку',
      notProfiled: 'Профиль ещё не рассчитан',
      startProfiling: 'Профилировать',
      enqueued: 'Профилирование запущено. Подождите...',
      totalRows: 'Всего строк',
      nonNull: 'Не NULL',
      nullPercent: '% NULL',
      distinctCount: 'Уникальных значений',
      numericStats: 'Числовая статистика',
      min: 'Мин',
      max: 'Макс',
      avg: 'Среднее',
      median: 'Медиана',
      stddev: 'Станд. отклонение',
      textStats: 'Текстовая статистика',
      minLength: 'Мин длина',
      maxLength: 'Макс длина',
      avgLength: 'Сред. длина',
      profiledAt: 'Профилировано',
      topValues: 'Топ-10 значений',
      value: 'Значение',
      count: 'Количество',
      percentage: 'Процент',
    },
    profiling: {
      title: 'Профилирование',
      refresh: 'Обновить',
      settingsTitle: 'Настройки профилирования',
      maxConcurrent: 'Параллельных задач',
      windowStart: 'Окно с',
      windowEnd: 'по',
      saveSettings: 'Сохранить',
      timeHint: 'Время указано по локальному времени',
      queueTitle: 'Очередь профилирования',
      historyTitle: 'История профилирования',
      queueEmpty: 'Очередь пуста',
      historyEmpty: 'История пока пуста',
      schema: 'Схема',
      table: 'Таблица',
      column: 'Поле',
      status: 'Статус',
      createdAt: 'Создано',
      startedAt: 'Запущено',
      completedAt: 'Завершено',
      duration: 'Длительность',
      error: 'Ошибка',
      statusPending: 'В очереди',
      statusProcessing: 'В работе',
      statusCompleted: 'Успешно',
      statusFailed: 'Ошибка',
      queueLoadFailed: 'Не удалось загрузить очередь профилирования',
      historyLoadFailed: 'Не удалось загрузить историю профилирования',
      settingsLoadFailed: 'Не удалось загрузить настройки профилирования',
      settingsSaveFailed: 'Не удалось сохранить настройки профилирования',
      settingsSaved: 'Настройки профилирования сохранены',
    },
    metadataSync: {
      title: 'Синхронизация метаданных',
      refresh: 'Обновить данные',
      currentTask: 'Текущая задача',
      // Состояние задачи, а НЕ признак причины отказа: возврат в ожидание
      // перезапуском отказом не является — попытка не потрачена, задача
      // выполнится сама (api-errors-R12, data-processing-metadata-sync-R10).
      // Потому текст живёт здесь, а не в пространстве `errors.`.
      returnedAfterRestart: 'Задача возвращена в очередь после перезапуска сервиса и будет выполнена заново',
      historyTitle: 'История синхронизаций',
      empty: 'Задач синхронизации нет',
      historyEmpty: 'История синхронизаций пока пуста',
      status: 'Статус',
      startedAt: 'Запущено',
      completedAt: 'Завершено',
      duration: 'Длительность',
      schemas: 'Схемы',
      tables: 'Таблицы',
      columns: 'Поля',
      error: 'Ошибка',
      statusPending: 'В очереди',
      statusProcessing: 'В работе',
      statusCompleted: 'Успешно',
      statusFailed: 'Ошибка',
      queueLoadFailed: 'Не удалось загрузить очередь синхронизации',
      historyLoadFailed: 'Не удалось загрузить историю синхронизаций',
      queued: 'Синхронизация метаданных поставлена в очередь',
    },
  },

  versioning: {
    commit: 'Commit',
    history: 'История',
    loadHistoryError: 'Не удалось загрузить историю',
    commitTitle: 'Создать коммит',
    commitMessage: 'Сообщение коммита',
    commitMessagePlaceholder: 'Опишите изменения (опционально)',
    commitSuccess: 'Коммит успешно создан',
    commitError: 'Не удалось создать коммит',
    historyTitle: 'История коммитов',
    noHistory: 'История пуста',
    noMessage: 'Без описания',
    checkout: 'Checkout',
    checkoutTitle: 'Создать ветку',
    branchName: 'Имя ветки',
    branchNamePlaceholder: 'Введите имя новой ветки',
    branchNameHint: 'Оставьте пустым для автоматического имени',
    checkoutSuccess: 'Ветка успешно создана',
    checkoutError: 'Не удалось создать ветку',
    by: 'от',
    // Отказы версионирования доходят до пользователя причиной, а не
    // обобщённым «не удалось» (business-model/versioning.md, api-errors-R08):
    // «нет права» — отказ в доступе (BUG-0071). Одна причина у разных
    // операций называется своим текстом, поэтому у операции своё
    // пространство отказов (BUG-0073).
    checkoutFailure: {
      errors: {
        ACCESS_DENIED: 'Недостаточно прав на создание ветки',
      },
    },
    commitFailure: {
      errors: {
        ACCESS_DENIED: 'Недостаточно прав на создание коммита',
        // Коммит архивного коммита, в том числе ставшего архивным
        // одновременным коммитом (business-model-versioning-R04, R29).
        FEATURE_NOT_HEAD: 'Нельзя коммитить архивную фичу: коммит доступен только для HEAD',
      },
    },
    // Отказ загрузки истории версий показывается причиной (api-errors-R09,
    // R08; BUG-0075).
    historyFailure: {
      errors: {
        ACCESS_DENIED: 'Недостаточно прав на просмотр истории версий',
      },
    },
  },

  /**
   * Фича как объект: перечень, заведение, свойства, статусы, удаление.
   * Норма: spec/backend/business-model/features.md,
   * spec/backend/business-model/feature-lifecycle.md.
   */
  feature: {
    createStandalone: 'создать фичу',
    select: 'Фича',
    create: 'Создать фичу...',
    createTitle: 'Создать фичу',
    name: 'Название фичи',
    namePlaceholder: 'Введите название фичи',
    description: 'Описание',
    descriptionPlaceholder: 'Введите описание фичи',
    created: 'Фича «{name}» создана',
    loadError: 'Не удалось загрузить перечень фич',
    createError: 'Не удалось создать фичу',
    selectProjectFirst: 'Сначала выберите проект',
    // Фича из ссылки не принадлежит проекту адреса: открыта другая, и об этом
    // сообщается — молчаливого переноса выбора между проектами нет
    // (shell-routing-R12, features-R10).
    notInLinkProject: 'Фича из ссылки в этом проекте недоступна — открыта другая',
    // Перечень фич проекта (feature-lifecycle-R11)
    manageTitle: 'Фичи проекта',
    listEmpty: 'В проекте нет фич',
    selected: 'выбрана',
    // Архивные фичи на поверхности (feature-lifecycle-R28)
    showArchived: 'Показывать архивные',
    restore: 'Вернуть из архива',
    restoreTitle: 'Вернуть фичу из архива',
    restored: 'Фича «{name}» возвращена из архива',
    // Диалог свойств (feature-lifecycle-R04, R08)
    properties: 'Свойства',
    propertiesTitle: 'Свойства фичи',
    status: 'Статус',
    statuses: {
      draft: 'Черновик',
      in_progress: 'В работе',
      review: 'На проверке',
      merged: 'Влита',
      archived: 'Архивная',
    },
    saved: 'Изменения сохранены',
    // Подтверждение удаления (feature-lifecycle-R14, R18)
    deleteTitle: 'Удалить фичу «{name}»?',
    deleteCascade: 'Вместе с фичей будут удалены её бизнес-модель и маппинги.',
    deleteIrreversible: 'Действие необратимо: восстановить фичу будет нельзя, и отменой удаление не откатывается.',
    deleteArchiveHint: 'Чтобы скрыть фичу, сохранив её содержимое, переведите её в статус «Архивная» вместо удаления.',
    deleted: 'Фича «{name}» удалена',
  },

  markdownEditor: {
    preview: 'Просмотр',
    previewTooltip: 'Показать заметку так, как её увидят другие',
    previewEmpty: 'Заметка пуста',
    formatHint: 'Формат заметки — Markdown. Разметка HTML не принимается; чтобы показать её примером, поместите её в код.',
    boldTooltip: 'Жирный',
    boldPlaceholder: 'жирный текст',
    italicTooltip: 'Курсив',
    italicPlaceholder: 'курсив',
    strikeTooltip: 'Зачёркнутый',
    strikePlaceholder: 'зачёркнутый текст',
    codeTooltip: 'Код',
    codePlaceholder: 'код',
    headingTooltip: 'Заголовок',
    bulletListTooltip: 'Маркированный список',
    orderedListTooltip: 'Нумерованный список',
    quoteTooltip: 'Цитата',
    linkTooltip: 'Вставить ссылку',
    linkLabel: 'ссылка',
    promptEnterLinkUrl: 'Введите адрес ссылки:',
    imageLabel: 'изображение',
    imageSizeExceeded: 'Размер изображения не должен превышать 5 МБ',
    invalidImageFile: 'Загрузите файл изображения',
    imageReadFailed: 'Не удалось прочитать изображение',
    uploadImageTooltip: 'Загрузить изображение',
    insertImageUrlTooltip: 'Вставить изображение по адресу',
    promptEnterImageUrl: 'Введите адрес изображения:',
  },

  richTextEditor: {
    imageSizeExceeded: 'Размер изображения не должен превышать 5 МБ',
    invalidImageFile: 'Загрузите файл изображения',
    imageReadFailed: 'Не удалось прочитать изображение',
    uploadImageTooltip: 'Загрузить изображение',
    insertImageUrlTooltip: 'Вставить изображение по URL',
    promptEnterImageUrl: 'Введите URL изображения:',
  },

  bm: {
    packages: {
      confirmDeletePackage: 'Удалить пакет "{name}" и всё его содержимое?',
      confirmDeleteDiagram: 'Удалить диаграмму "{name}"?',
      deletePackageTitle: 'Удалить пакет',
      deleteDiagramTitle: 'Удалить диаграмму',
    },
    tree: {
      title: 'Пакеты и диаграммы',
      // Отказ группового перемещения называет узел, на котором он произошёл
      // (business-model-packages-R21, R22).
      moveNodeFailed: 'Не удалось переместить «{name}»',
      contextMenu: {
        createPackage: 'Создать пакет',
        createDiagram: 'Создать диаграмму',
        createClass: 'Создать класс',
        rename: 'Переименовать',
        delete: 'Удалить',
        editClass: 'Редактировать',
        renameClass: 'Переименовать',
        deleteClass: 'Удалить класс',
        confirmDeleteClass: 'Удалить класс "{name}"? Это действие нельзя отменить.',
        deleteClassTitle: 'Удалить класс',
      },
    },
    toolbar: {
      createClass: 'Создать класс',
      className: 'Класс',
      undo: 'Отменить (Ctrl+Z)',
      redo: 'Повторить (Ctrl+Shift+Z)',
      save: 'Сохранить (Ctrl+S)',
      saveName: 'Сохранить',
      zoomIn: 'Увеличить',
      zoomOut: 'Уменьшить',
      fitView: 'По размеру экрана',
      unlock: 'Разблокировать',
      lock: 'Заблокировать',
      hideMinimap: 'Скрыть миникарту',
      showMinimap: 'Показать миникарту',
      disableSnapToGrid: 'Выключить привязку к сетке',
      enableSnapToGrid: 'Включить привязку к сетке',
      exportPng: 'Экспорт в PNG',
      exportSuccess: 'Диаграмма экспортирована',
      exportError: 'Не удалось экспортировать диаграмму',
    },
    hiddenEdges: 'Есть скрытые связи',
    noFields: 'Нет полей',
    noValues: 'Нет значений',
    canvas: {
      loadingGraph: 'Загрузка графа...',
      openDiagramHint: 'Откройте диаграмму из списка слева',
    },
    contextMenu: {
      createClass: 'Создать класс',
      showAllEdges: 'Показать все связи',
      removeFromDiagram: 'Убрать с диаграммы',
      deleteClass: 'Удалить класс',
      hideEdge: 'Скрыть связь',
    },
    diagram: {
      defaultName: 'диаграмму',
      saveError: 'Ошибка сохранения диаграммы',
      changesSaved: 'Изменения сохранены',
      noDiagramSelected: 'Диаграмма не выбрана',
      classAlreadyOnDiagram: 'Класс уже на диаграмме',
      unsavedChangesConfirm: 'Диаграмма "{name}" содержит несохранённые изменения.\n\nСохранить изменения перед закрытием?',
      classCreatedLocally: 'Класс создан локально. Сохраните изменения.',
      changesLocalSave: 'Изменения сохранены локально. Сохраните диаграмму.',
      classCreated: 'Класс создан',
      createClassError: 'Не удалось создать класс',
    },
    errors: {
      MISSING_SOURCE_ID: 'Источник не выбран. Выберите источник и повторите',
      // Панель образца и вкладка «Данные» локализуют отказ выборки по признаку
      // причины (source-explorer-sample-data-R16, R41; api-errors-R08).
      TABLE_NAME_AMBIGUOUS: 'Имя таблицы «{entityId}» неоднозначно: в источнике несколько таблиц с таким полным именем',
      // Поле без выбранного типа и цикл наследования (fields-R29, classes-R12)
      FIELD_TYPE_NOT_SELECTED: 'У поля «{field}» не выбран тип: класс не сохранён',
      // Отказы составного действия «класс вместе с полями» (classes-R25, R26):
      // при сбое любой части действие отклоняется целиком, и пользователь
      // видит именно его причину, а не обобщённый текст (api-errors-R05, R08).
      CLASS_NAME_EXISTS: 'Класс с названием «{name}» в этой фиче уже есть',
      CLASS_NAME_EMPTY: 'Название класса не может быть пустым',
      FIELD_NAME_EXISTS: 'Поле с названием «{name}» в этом классе уже есть: класс не сохранён',
      FIELD_NAME_EMPTY: 'Название поля не может быть пустым: класс не сохранён',
      ENUM_VALUE_EXISTS: 'Значение «{value}» в этом перечислении уже есть: класс не сохранён',
      ENUM_VALUE_EMPTY: 'Значение перечисления не может быть пустым: класс не сохранён',
      CLASS_TYPE_CANNOT_HAVE_FIELDS: 'Класс этого типа полей не имеет',
      CLASS_IS_NOT_ENUM: 'Значения перечисления есть только у перечисления',
      DIAGRAM_FROM_ANOTHER_FEATURE: 'Диаграмма «{name}» принадлежит другой фиче — разместить на ней класс нельзя',
      MIN_CARDINALITY_NEGATIVE: 'Нижняя граница количества не может быть отрицательной',
      MAX_CARDINALITY_LESS_THAN_MIN: 'Верхняя граница количества не может быть меньше нижней',
      CLASS_INHERITANCE_CYCLE: 'Класс не может стать своим предком: это замкнуло бы наследование в кольцо',
      CLASS_HAS_CHILDREN: 'Невозможно удалить класс: есть {count} дочерних классов',
      CLASS_HAS_REFERENCES: 'Невозможно удалить класс: на него ссылаются {count} полей',
      // Удаление пакета с классами в нём или в подпакетах блокируется
      // (spec/backend/business-model/packages.md, business-model-packages-R25).
      PACKAGE_HAS_CLASSES: 'Невозможно удалить пакет: в нём или в его подпакетах есть классы',
      CANNOT_DELETE_PRIMITIVE: 'Невозможно удалить примитивный тип',
      CANNOT_CREATE_PRIMITIVE: 'Создание примитивных типов запрещено',
      CANNOT_MODIFY_PRIMITIVE: 'Примитивный тип — константа платформы: изменить его нельзя',
      ENUM_CANNOT_CHANGE_TYPE: 'Тип перечисления не может быть изменён',
      PRIMITIVE_CANNOT_CHANGE_TYPE: 'Тип примитива не может быть изменён',
      INVALID_TYPE_CHANGE: 'Недопустимая смена типа класса',
      EXTENSION_CANNOT_BE_ABSTRACT: 'Расширение не может быть абстрактным',
      ENUM_CANNOT_BE_ABSTRACT: 'Перечисление не может быть абстрактным',
      ONLY_CONCRETE_CAN_HAVE_PARENT: 'Только классы могут иметь родителя',
      PARENT_MUST_BE_ABSTRACT: 'Родитель должен быть абстрактным классом',
      PRIMITIVE_CANNOT_BE_REFERENCE: 'Примитивный тип не может быть ссылкой',
      // Изоляция фичи: ссылка объекта фичи ведёт только на объект той же фичи
      // (spec/backend/invariants/feature-isolation.md, R01, R04, R06).
      PACKAGE_FROM_ANOTHER_FEATURE: 'Пакет "{name}" принадлежит другой фиче — объект нельзя в него поместить',
      PARENT_PACKAGE_FROM_ANOTHER_FEATURE: 'Пакет "{name}" принадлежит другой фиче — его нельзя сделать родительским',
      PARENT_CLASS_FROM_ANOTHER_FEATURE: 'Класс "{name}" принадлежит другой фиче — его нельзя сделать родительским',
      TYPE_CLASS_FROM_ANOTHER_FEATURE: 'Класс-тип поля принадлежит другой фиче',
      EDGE_FIELD_FROM_ANOTHER_FEATURE: 'Поле "{name}" принадлежит другой фиче — его связь на этой диаграмме скрыть нельзя',
      // Размещаемый класс принадлежит фиче диаграммы
      // (spec/backend/business-model/diagrams.md, business-model-diagrams-R55).
      CLASS_FROM_ANOTHER_FEATURE: 'Класс "{name}" принадлежит другой фиче — разместить его на этой диаграмме нельзя',
      EDGE_CLASS_FROM_ANOTHER_FEATURE: 'Класс "{name}" принадлежит другой фиче — его связь на этой диаграмме скрыть нельзя',
      CLASS_NOT_FOUND: 'Класс не найден',
      FIELD_NOT_FOUND: 'Поле не найдено',
      ENUM_VALUE_NOT_FOUND: 'Значение перечисления не найдено',
      DELETE_FAILED: 'Не удалось удалить',
      CREATE_FAILED: 'Не удалось создать',
      UPDATE_FAILED: 'Не удалось обновить',
      LOAD_FAILED: 'Не удалось загрузить бизнес-модель',
      UNKNOWN_ERROR: 'Неизвестная ошибка',
    },
    export: {
      // Итог выгрузки с предупреждениями (export-R10, R11)
      completedWithWarnings: 'Выгружено с предупреждениями',
      warningDiagram: 'не удалось получить изображение диаграммы «{name}»',
      warningPackage: 'не удалось получить диаграммы пакета «{name}»',
      button: 'Экспорт документации',
      title: 'Экспорт документации',
      progress: 'Экспорт: {progress}%',
      success: 'Документация успешно экспортирована',
      error: 'Не удалось экспортировать документацию',
      exporting: 'Экспорт...',
      // Подписи выгружаемого комплекта: он — пользовательская поверхность
      // продукта, его тексты берутся из словарей на языке выгрузки
      // (export-R27, i18n-R02). Названия объектов модели не переводятся.
      document: {
        heading: 'Документация модели «{name}»',
        generatedBy: 'Сформировано в MetaBridge',
        navigation: 'Дерево навигации',
        searchPlaceholder: 'Поиск по названию',
        searchAction: 'Найти',
        nodeExpand: 'Раскрыть узел',
        nodeCollapse: 'Свернуть узел',
        searchEmpty: 'Ничего не найдено',
        diagrams: 'Диаграммы',
        subPackages: 'Подпакеты',
        classes: 'Классы',
        documentation: 'Описание',
        generalization: 'Родительский класс',
        inheritors: 'Наследники',
        enumValues: 'Значения перечисления',
        attributes: 'Поля',
        abstract: 'абстрактный',
        columnValue: 'Значение',
        columnDocumentation: 'Описание',
        columnName: 'Имя',
        columnType: 'Тип',
        columnCardinality: 'Кратность',
      },
      steps: {
        fetchingGraph: 'Загрузка графа...',
        fetchingPackages: 'Загрузка пакетов...',
        generatingHtml: 'Генерация HTML...',
        creatingZip: 'Создание архива...',
        generatingPackages: 'Генерация страниц пакетов...',
        downloading: 'Скачивание...',
      },
    },
  },

  admin: {
    users: {
      title: 'Пользователи',
      fullName: 'Полное имя',
      login: 'Логин',
      email: 'Email',
      role: 'Роль',
      status: 'Статус',
      active: 'Активен',
      inactive: 'Заблокирован',
      isAdmin: 'Администратор',
      editUser: 'Редактировать',
      resetPassword: 'Сбросить пароль',
      newPassword: 'Новый пароль',
      mustChangePassword: 'Требовать смену при входе',
      saveSuccess: 'Пользователь обновлён',
      resetSuccess: 'Пароль сброшен',
      cannotDeactivateSelf: 'Нельзя деактивировать себя',
      createUser: 'Создать пользователя',
      createSuccess: 'Пользователь создан',
      password: 'Пароль',
      passwordHint: 'Минимум {min} символов',
      blockUser: 'Заблокировать',
      unblockUser: 'Разблокировать',
      userBlocked: 'Пользователь заблокирован',
      userUnblocked: 'Пользователь разблокирован',
      blockTitle: 'Заблокировать пользователя «{login}»?',
      blockExplanation: 'Пользователь потеряет доступ к продукту.',
      validation: {
        required: 'Обязательное поле',
        login: 'Недопустимый формат логина',
        password: 'Минимум 8 символов',
      },
      errors: {
        ACCESS_DENIED: 'Доступ запрещён',
        USER_NOT_FOUND: 'Пользователь не найден',
        CANNOT_DEACTIVATE_SELF: 'Нельзя деактивировать себя',
        PASSWORD_TOO_WEAK: 'Пароль слишком слабый',
        LOGIN_ALREADY_EXISTS: 'Логин уже занят',
        EMAIL_ALREADY_EXISTS: 'Email уже занят',
        INVALID_LOGIN_FORMAT: 'Логин может содержать только строчные латинские буквы, цифры, _ и -',
        UNKNOWN_ERROR: 'Неизвестная ошибка',
      },
    },
  },

  connection: {
    types: {
      database: 'База данных',
      ftp: 'FTP',
      sftp: 'SFTP',
      s3: 'S3',
      local_path: 'Локальный путь',
      webapi: 'Web API',
      kafka: 'Kafka',
    },
    dataProviders: {
      database: 'База данных',
      excel: 'Excel',
      csv: 'CSV',
      json: 'JSON',
      xml: 'XML',
    },
    addGroup: 'Добавить группу',
    addConnection: 'Добавить подключение',
    connectionType: 'Тип подключения',
    dataProvider: 'Провайдер данных',
    testConnection: 'Проверить подключение',
    addChildItem: 'Добавить элемент',
    s3: {
      bucket: 'Bucket',
      region: 'Регион',
      accessKey: 'Access Key',
      secretKey: 'Secret Key',
    },
    webApi: {
      baseUrl: 'Base URL',
      authType: 'Тип авторизации',
      authNone: 'Нет',
      authBearer: 'Bearer Token',
      authBasic: 'Базовая аутентификация',
      authApiKey: 'API Key',
      tokenKey: 'Токен / Ключ',
      headerName: 'Имя заголовка',
    },
    kafka: {
      brokers: 'Брокеры',
      securityProtocol: 'Протокол безопасности',
      plaintext: 'Plaintext',
      ssl: 'SSL',
      saslSsl: 'SASL_SSL',
      saslPlaintext: 'SASL_PLAINTEXT',
      saslMechanism: 'SASL Механизм',
      schemaRegistryUrl: 'Schema Registry URL',
    },
  },

  filePattern: {
    filePatterns: 'Файловые маски',
    name: 'Название',
    fileMask: 'Маска файла',
    filePath: 'Путь к файлу',
    addFilePattern: 'Добавить маску',
    addTitle: 'Добавить файловую маску',
    fileMaskPlaceholder: '*.csv, report_*.xlsx',
    filePathPlaceholder: '/data/reports',
    dataProvider: 'Формат данных',
    delimiter: 'Разделитель',
    encoding: 'Кодировка',
    headerRow: 'Строка заголовка',
    deleteConfirm: 'Удалить маску \u00AB{name}\u00BB?',
  },

  endpoint: {
    endpoints: 'Endpoints',
    name: 'Название',
    method: 'HTTP метод',
    path: 'Путь',
    addEndpoint: 'Добавить endpoint',
    addTitle: 'Добавить endpoint',
    methodPlaceholder: 'GET',
    pathPlaceholder: '/api/users',
    deleteConfirm: 'Удалить endpoint \u00AB{name}\u00BB?',
  },

  topic: {
    topics: 'Топики',
    name: 'Название',
    topicName: 'Имя топика',
    addTopic: 'Добавить топик',
    addTitle: 'Добавить топик',
    topicNamePlaceholder: 'events.orders',
    deleteConfirm: 'Удалить топик \u00AB{name}\u00BB?',
  },

  undoRedo: {
    undo: 'Отменить',
    redo: 'Повторить',
    nothingToUndo: 'Нечего отменять',
    nothingToRedo: 'Нечего повторять',
    undoFailed: 'Не удалось отменить действие',
    redoFailed: 'Не удалось повторить действие',
    conflict: 'Конфликт: изменение затронуто более поздней правкой',
    /**
     * Тексты отказов отмены и возврата по признаку причины
     * (undo-redo-R19, i18n-R06): каждый отказ доводится до пользователя, и
     * молчаливое гашение недопустимо. Имён хранения в текстах нет — перечень
     * видов сущностей задаёт audit-R12 (undo-redo-R18).
     */
    errors: {
      // Отмена и возврат доступны только при выбранной фиче (versioning-R21)
      FEATURE_NOT_SELECTED: 'Фича не выбрана',
      NOTHING_TO_UNDO: 'Нечего отменять',
      NOTHING_TO_REDO: 'Нечего возвращать',
      CONFLICT: 'Конфликт: изменение затронуто более поздней правкой',
      SESSION_NOT_FOUND: 'Сеанс редактирования не найден',
      SESSION_CLOSED: 'Сеанс редактирования закрыт',
      ACCESS_DENIED: 'Недостаточно прав на отмену этого изменения',
      STORAGE_ERROR: 'Отмена не удалась',
      NETWORK_ERROR: 'Отмена не удалась: нет связи с сервером',
    },
  },
};
